import { createSlice } from "@reduxjs/toolkit";
import { addCityAction } from "../actions/addCityAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const addCitySlice = createSlice({
  name: "addCity",
  initialState,
  reducers: {
    // clearaddCityState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCityAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCityAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addCityAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { clearaddCityState } = addCitySlice.actions;
export default addCitySlice.reducer;
